class CompaniesController {
    /*@ngInject*/
    constructor($rootScope, $state, $timeout, moment, companyService, planService, userRoleService, utilityService, StorageService, stateManagementStorageService, MESSAGECONSTANTS, userService) {
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.moment = moment;
        this.companyService = companyService;
        this.planService = planService;
        this.userRoleService = userRoleService;
        this.utilityService = utilityService;
        this.StorageService = StorageService;
        this.stateManagementStorageService = stateManagementStorageService;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
        this.userService = userService;
    }
    $onInit() {
        this.companies = [];
        this.searchTerm = '';
        this.showLogoutButtonInPopup = false;
        this.companyListLoaded = false;
        this.disableLogoutButton = true;
        this.isSuperUser = this.userRoleService.isLoggedInUserSuperUser();
        this._getAllCompanies();
    }
    _getAllCompanies() {
        this.companyService.getAllCompanies((data) => {
            if (data.length == 0) {
                this.showLogoutButtonInPopup = true;
            }
            this.companies = [];
            data.forEach((company) => {
                if (!this._checkCompanyExists(company)) {
                    company.companyStateLabel = company.companyState == 'SoftHold' ? 'Soft Hold' : company.companyState;
                    this.companies.push(company);
                }
            });
            this.companyListLoaded = true;
            this.$timeout(() => {
                this.disableLogoutButton = false;
            }, 2000);
            if (typeof callback != "undefined") {
                return callback(this.companies);
            }
        }, error => {
            this.$rootScope.throwError(error);
            if (typeof callback != "undefined") {
                return callback("done");
            }
        });
    }
    getCompany(company) {
        this.searchTerm = '';
        this.$rootScope.companyDeletedShowPopup = false;
        this.$rootScope.SelectedCompanyId = company.companyId;
        this.$rootScope.CompanySelectedFromPopup = true;
        this.$rootScope.showNotificationsIcon = false;
        if (this.StorageService.get('SelectedHostCompany') != null) {
            this.StorageService.set('SelectedHostCompany', null);
        }
        if (company.companyType == 'Host') {
            this.StorageService.set('SelectedHostCompany', company);
        }
        else {
            this.StorageService.set('companyDetails', company);
        }
        this.$rootScope.userDetails.company.companyId = company.companyId;
        this.$rootScope.userDetails.company.companyName = company.companyName;
        this.$rootScope.userDetails.company.companyType = company.companyType;
        this.$rootScope.userDetails.company.companyState = company.companyState;
        this.companyService.setCompanyStateLabel();
        this.stateManagementStorageService.clearStatesOfScreens();
        this.$rootScope.userDetails.company.companySelected = true;
        this.getPlan(company.companyId);
    }
    getPlan(companyId) {
        this.utilityService.showLoadingModal("Loading...");
        this.planService.getCurrentPlan(companyId, (data) => {
            if (data !== "" && data !== null) {
                this.$rootScope.userDetails.plan.planName = data.planHeaderDto.planName;
                this.$rootScope.userDetails.plan.startDate = this.moment(data.planHeaderDto.planStartDate);
                this.$rootScope.userDetails.plan.endDate = this.moment(data.planHeaderDto.planEndDate);
                this.$rootScope.userDetails.plan.planType = data.planHeaderDto.planType;
            }
            this.StorageService.set('userDetails', this.$rootScope.userDetails, { 'expires': new Date(Date.now() + this.$rootScope.tokenvalidity) });
            this.$rootScope.switchClicked = false;
            this.$rootScope.$emit("CompanySwitched");
            this.destroyModal();
            this.$timeout(() => {
                if (this.$rootScope.userDetails.roleScreenRef.role.name === '4dot5SuperUser' && this.$rootScope.userDetails.company.companyType === 'Host') {
                    this.$state.go('missioncontrol.companymanagement', { 'selectedCompanyId': companyId, 'vendorId': null, 'clientOrBuObject': null }, { reload: true });
                }
                else {
                    if (this.StorageService.get('companyDetails') != null && this.$rootScope.userDetails.company.companyState == 'Active') {
                        if (this.$rootScope.userDetails.plan.planName !== 'Vendor Only') {
                            this.$state.go('missioncontrol.dashboard', null, { reload: true });
                        }
                        else {
                            this.$state.go('missioncontrol.requisitions', null, { reload: true });
                        }
                    }
                    else {
                        this.$state.go('missioncontrol.companymanagement', { clientOrBuObject: null, vendorId: null, clientOrBuObject: null }, { reload: true });
                    }
                }
                this.utilityService.hideLoadingModal();
                let userCacheObject = {
                    userId: this.$rootScope.userDetails.id,
                    loggedInCompanyId: this.$rootScope.userDetails.company.companyId
                };
                // Invoke user cache in order to save the users in in-memory-cache.
                this.userService.userCache(userCacheObject, () => { }, (error) => { console.log(error); });
            }, 500);
            this.$rootScope.showNotificationsIcon = true;
        }, (error) => {
            this.$rootScope.throwError(error);
            if (typeof callback != "undefined") {
                return callback("done");
            }
        });
    }
    destroyModal() {
        this.$rootScope.switchCompanyRepeat = 0;
        this.$rootScope.switchClicked = false;
        this.closeModal();
    }
    addCompany() {
        this.destroyModal();
        this.$rootScope.companyDeletedShowPopup = false;
        this.StorageService.remove('companyDetails');
        this.StorageService.remove('SelectedHostCompany');
        this.$rootScope.userDetails.company.companyId = null;
        this.$rootScope.userDetails.company.companyName = null;
        this.$rootScope.userDetails.company.companyType = null;
        this.$rootScope.userDetails.company.companyState = 'Draft';
        this.companyService.setCompanyStateLabel();
        this.$rootScope.userDetails.company.companySelected = false;
        this.StorageService.set('userDetails', angular.copy(this.$rootScope.userDetails), { 'expires': new Date(Date.now() + this.$rootScope.tokenvalidity) });
        this.$state.go('missioncontrol.companymanagement', { companyObject: this.$rootScope.userDetails.company }, { reload: true });
    }
    logoutAsNoCompaniesRelated() {
        this.destroyModal();
        this.$timeout(() => {
            this.$rootScope.$emit("CallLogoutMethod");
        }, 200);
    }
    ;
    //method
    dismissModalAndDestroy() {
        this.$rootScope.switchClicked = false;
        this.destroyModal();
    }
    closeModal() {
        this.modalInstance.close(this.callbackObject);
    }
    dismissModal() {
        this.modalInstance.dismiss('cancel');
    }
    _checkCompanyExists(element) {
        for (let i = 0; i < this.companies.length; i++) {
            if ((this.companies[i].companyId === element.companyId) && (this.companies[i].companyName === element.companyName)) {
                return true;
            }
        }
        return false;
    }
    ;
}
CompaniesController.$inject = ['$rootScope', '$state', '$timeout', 'moment', 'companyService', 'planService', 'userRoleService', 'utilityService', 'StorageService', 'stateManagementStorageService', 'MESSAGECONSTANTS', 'userService'];
// import * as TEMPLATE from './companies.html';
import * as TEMPLATE from 'raw-loader!./companies.html';
export const CompaniesComponent = {
    selector: 'companies',
    component: {
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controller: CompaniesController,
        // templateUrl: 'app/shared/companies/companies.html'
        template: TEMPLATE.default
    }
};
//# sourceMappingURL=companies.component.js.map